import ImageUploadWidget from './ImageUploadWidget';

export default ImageUploadWidget;


// WEBPACK FOOTER //
// ./src/components/ImageUploadWidget/index.js